export const slugifyPackageName = (name = '') =>
    name.trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');

// Matches a coin package from GET /api/payment/coin-packages to its RevenueCat
// Package, primarily via the backend-provided `revenueCatProductId` (the
// identifier of the Web Billing product/package configured in the RevenueCat
// dashboard). Falls back to coinPackageId / a slug of the name for packages
// that predate that field.
export const findRevenueCatPackage = (offering, coinPackage) => {
    if (!offering || !coinPackage) return null;

    const candidates = offering.availablePackages || [];
    const nameSlug = slugifyPackageName(coinPackage.name);

    return (
        (coinPackage.revenueCatProductId && (
            candidates.find(pkg => pkg.identifier === coinPackage.revenueCatProductId) ||
            candidates.find(pkg => pkg.webBillingProduct?.identifier === coinPackage.revenueCatProductId)
        )) ||
        candidates.find(pkg => pkg.identifier === coinPackage.coinPackageId) ||
        candidates.find(pkg => pkg.webBillingProduct?.identifier === coinPackage.coinPackageId) ||
        candidates.find(pkg => pkg.identifier === nameSlug) ||
        candidates.find(pkg => slugifyPackageName(pkg.webBillingProduct?.title) === nameSlug) ||
        null
    );
};
